import { httpsCallable } from "firebase/functions";
import { getFirebaseFunctions } from "./firebase/index.js";

export interface ContactEmailRequest {
  clientId: string;
  customerName: string;
  customerEmail: string;
  subject: string;
  /** Arbitrary key-value pairs rendered as a table in the notification email. */
  fields: { label: string; value: string }[];
  /** Optional message shown in the customer confirmation email. Defaults to a generic reply. */
  confirmationMessage?: string;
}

/**
 * Send a transactional email on behalf of a client site.
 *
 * To enable for a new client:
 *   1. Add the client to CLIENT_EMAIL_CONFIG in functions/src/clientEmailConfig.ts.
 *   2. Call this function from the client app with that clientId.
 *   No other changes needed.
 */
export async function sendContactEmail(req: ContactEmailRequest): Promise<void> {
  const fn = httpsCallable<ContactEmailRequest, { success: boolean }>(
    getFirebaseFunctions(),
    "sendContactEmail",
  );
  await fn(req);
}
